import Settings from "./index";
// import middlewares
export default [
  {
    path: "/settings",
    component: Settings,
    name: "Settings",
  },
];
